import { css } from 'emotion'

export const UserInviteCardStyles = css``
